<template>
  <div>
    <wc-data-box
      :title='header.title'
      :titleIcon='header.icon'
      :titleIconColor='header.color'
      :showEdit='!invoice.archived && !invoice.is_uncollectible'
      @edit='edit'
    >
      <wc-two-column-table :items='data'></wc-two-column-table>
      <v-card-text v-html='invoice_edit.terms'></v-card-text>
    </wc-data-box>
    <wc-dialog
      :showDialog='showDialog'
      :title='header.title'
      :icon='header.icon'
      :iconColor='header.color'
      @cancel='showDialog = false'
      @save='save'
      width='450'
    >
      <v-form v-model='isFormValid'>
        <v-row>
          <v-col cols='12' md='4'>
            <v-text-field
              v-model='invoice_edit.interest'
              label='Monthly interest'
              :rules='[rules.decimal]'
              append-icon='mdi-percent'
              reverse
            ></v-text-field>
          </v-col>
          <v-col cols='12'>
            <v-text-field
              v-model='invoice_edit.terms'
              label='Terms'
              hint="eg: 'Net 30' - set in division settings to auto-fill this"
              persistent-hint
            ></v-text-field>
          </v-col>
        </v-row>
      </v-form>
    </wc-dialog>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import formRules from '@/mixins/formRules';
const MONTHLY_INTEREST = 'Monthly Interest';
const TERMS = 'Terms';

export default {
  name: 'invoice-details',
  mixins: [formRules],
  props: {
    invoice: {
      required: true
    }
  },
  created () {
    this.getData()
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    showDialog: false,
    showHoldDialog: false,
    invoice_edit: {},
    data: []
  }),
  computed: {
    ...mapState({
      header: state => state.icons.dataBox.details
    }),
  },
  methods: {
    edit () {
      this.showDialog = true;
    },
    save () {
      this.data.map(item =>{
        if(item.text === MONTHLY_INTEREST){
          const index = this.data.indexOf(item);
          const updated_interest = {
            text: MONTHLY_INTEREST, 
            value: this.$options.filters.percentage(this.invoice_edit.interest) 
          }
          this.data.splice(index, 1, updated_interest);
        }
      });
      this.$emit('update', this.invoice.id, this.invoice_edit);
      this.showDialog = false;
    },
    getData(){
      console.log(JSON.parse(JSON.stringify(this.invoice)))
      this.invoice_edit.interest = this.invoice.interest;
      this.invoice_edit.terms = this.invoice.terms;
      
      this.data.push({
        text: MONTHLY_INTEREST, value: this.$options.filters.percentage(this.invoice_edit.interest)
      });
      this.data.push({
        text: TERMS, value: ''
      });
    }
  }
}
</script>
